/**
 * usePermission — gate de UI por permisos de cargo.
 *
 * Espeja la semántica del backend (middleware requirePermiso en
 * server/src/middleware/auth.js):
 *   - admin (user.tipo === 'admin') siempre puede todo
 *   - "modulo"         → cualquier acción de ese módulo
 *   - "modulo.accion"  → esa acción específica
 *
 * Los permisos vienen de user.permisos (["modulo.accion", ...]), que /me
 * calcula desde el cargo activo del bombero vinculado.
 *
 * Uso:
 *   const puedeAprobar = usePermission('licencias.aprobar')
 *   const { can, esAdmin } = usePermissions()  // varios checks en un componente
 */
import { useSelector } from 'react-redux'

export function usePermissions() {
  const user = useSelector((state) => state.auth.user)
  const esAdmin = user?.tipo === 'admin'
  const permisos = user?.permisos || []
  const can = (moduloAccion) => {
    if (esAdmin) return true
    if (!moduloAccion) return false
    return permisos.some(
      (p) => p === moduloAccion || (!moduloAccion.includes('.') && p.startsWith(moduloAccion + '.'))
    )
  }
  return { can, esAdmin, permisos }
}

export default function usePermission(moduloAccion) {
  return usePermissions().can(moduloAccion)
}
